import React from "react";
import { motion } from "framer-motion";
import "bootstrap/dist/css/bootstrap.min.css";
import "./ClubhouseMeadows.css";

import {
  Activity,
  BedDouble,
  BookOpen,
  CircleDot,
  Dumbbell,
  Feather,
  Footprints,
  Gamepad2,
  Grid3X3,
  Music,
  Sparkles,
  Target,
  Trophy,
  Users,
  WavesLadder,
} from "lucide-react";

import clubhouseHero from "../../assets/meadows-images/meadows-clubhouse.avif";

const indoorAmenities = [
  { label: "Gym", icon: Dumbbell },
  { label: "Aerobic/Yoga and meditation hall", icon: Activity },
  { label: "Spa/sauna facility", icon: Sparkles },
  { label: "Integrated library and study lounge", icon: BookOpen },
  { label: "Banquet halls", icon: Users },
  { label: "Guest room", icon: BedDouble },
  { label: "Indoor games", icon: Gamepad2 },
  { label: "Squash courts", icon: CircleDot },
  { label: "Snooker tables", icon: Target },
  { label: "Indoor shuttle courts", icon: Feather },
  { label: "Table tennis", icon: CircleDot },
];

const outdoorAmenities = [
  { label: "Outdoor swimming pool, pool side lawns", icon: WavesLadder },
  { label: "Party lawns", icon: Music },
  { label: "Outdoor games", icon: Trophy },
  { label: "Basketball court", icon: Target },
  { label: "Cricket nets", icon: Grid3X3 },
  { label: "Tennis courts", icon: CircleDot },
  { label: "Walking track", icon: Footprints },
];

const containerVariants = {
  hidden: {},
  show: { transition: { staggerChildren: 0.1 } },
};

const fadeUp = {
  hidden: { opacity: 0, y: 45 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } },
};

export default function Clubhouse() {
  return (
    <section className="woods-clubhouse-section" id="woods-clubhouse">
      <div className="woods-clubhouse-hero">
        <img
          src={clubhouseHero}
          alt="Meadows clubhouse"
          className="woods-clubhouse-hero-img"
          loading="lazy"
        />
      </div>

      <div className="woods-clubhouse-amenities">
        <motion.div 
          className="container"
          variants={containerVariants}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.6 }}
        >
          <motion.div className="woods-clubhouse-header" variants={fadeUp}>
            <p className="woods-clubhouse-kicker">Clubhouse Amenities</p>
            <h2 className="woods-clubhouse-title">Indoor & Outdoor Experiences</h2>
          </motion.div>

          <div className="row g-4">
            <motion.div className="col-lg-6" variants={fadeUp}>
              <div className="woods-amenities-card">
                <div className="woods-amenities-heading">
                  <h3>Indoor amenities</h3>
                  <span className="woods-amenities-line" aria-hidden="true"></span>
                </div>
                <ul className="woods-amenities-grid">
                  {indoorAmenities.map((item) => {
                    const Icon = item.icon;
                    return (
                      <li className="woods-amenity-item" key={item.label}>
                        <span className="woods-amenity-box" aria-hidden="true">
                          <Icon size={13} />
                        </span>
                        <span className="woods-amenity-text">{item.label}</span>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </motion.div>

            <motion.div className="col-lg-6" variants={fadeUp}>
              <div className="woods-amenities-card">
                <div className="woods-amenities-heading">
                  <h3>Outdoor amenities</h3>
                  <span className="woods-amenities-line" aria-hidden="true"></span>
                </div>
                <ul className="woods-amenities-grid">
                  {outdoorAmenities.map((item) => {
                    const Icon = item.icon;
                    return (
                      <li className="woods-amenity-item" key={item.label}>
                        <span className="woods-amenity-box" aria-hidden="true">
                          <Icon size={13} />
                        </span>
                        <span className="woods-amenity-text">{item.label}</span>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
